/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const WindowMinimizeIconConfig = {
  name: 'WindowMinimizeIcon',
  height: 512,
  width: 512,
  svgPath: 'M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(WindowMinimizeIconConfig);